import CourseContent from "./components/courseContent";
import CourseHeader from "@/routes/course/components/courseHeader";
import CourseSidebar from "./components/courseSidebar";
import { useLoaderData } from "react-router-dom";
import { CourseLoaderData } from "@/routes/course/loaders/courseLoader.ts";

const CourseComponent = () => {
  const { course, courseProgress, isAuthenticated } = useLoaderData() as CourseLoaderData;

  return (
    <div className="flex flex-col lg:flex-row">
      <div className="flex-1 min-w-0 p-6">
        <CourseHeader
          name={course.name}
          description={course.description}
          level={course.level}
          durationMinute={course.durationMinute}
          isCertified={course.isCertified}
        />
        <CourseContent sections={course.sections} isOwned={course.isCoursePurchased} />
      </div>
      <div className="w-full lg:w-[420px] lg:shrink-0">
        <CourseSidebar
          courseId={course.id}
          isOwned={course.isCoursePurchased}
          isInTheBasket={course.isInTheBasket}
          totalLessons={course.totalLessons}
          courseProgress={courseProgress}
          enrolledStudents={course.purchasedCount}
          image={course.image}
          isCertified={course.isCertified}
          isAuthenticated={isAuthenticated}
          price={course.price}
          priceText={course.priceText}
          discountedPrice={course.discountedPrice}
          discountedPriceText={course.discountedPriceText}
          tags={course.tags}
          categories={course.categories}
        />
      </div>
    </div>
  );
};

export default CourseComponent;
